<div
  #editorRef
  class="editor-container border focus-within:border-sky-500 hover:border-sky-500"
></div>
